<template>
  <div>
    <DxPopup
      :visible="enabledPopUpTexture"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="auto"
      height="auto"
      :title="$t('registerProject.popPupTexture.title_groupItem_floorTexture')"
    >
      <div class="content-devx transparent">
        <DxForm
          col-count="auto"
          :col-count-by-screen="colCountByScreen"
          :screen-by-width="screenByWidth"
        >
          <DxSimpleItem
            :data-field="$t('registerProject.popPupTexture.nombre')"
            :col-span="4"
            :editor-options="{
              value: newTexture.name,
              onValueChanged: onChangeName,
            }"
          />
          <DxSimpleItem
            data-field=""
            editor-type="dxCheckBox"
            :editor-options="{
              value: checkBoxClay,
              onValueChanged: onCheckBoxClay,
            }"
          />
          <DxSimpleItem
            :col-span="3"
            :data-field="$t('registerProject.popPupTexture.arcilla')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: checkBoxClay ? newTexture.arcilla : calculateClay,
              onValueChanged: onChangeClay,
              mode: 'number',
              readOnly: checkBoxClay ? false : true,
            }"
          >
            <DxRangeRule
              min="0"
              max="100"
              :message="$t('outOfRange')"
            />
          </DxSimpleItem>
          <DxSimpleItem
            data-field=""
            editor-type="dxCheckBox"
            :editor-options="{
              value: checkBoxSand,
              onValueChanged: onCheckBoxSand,
            }"
          />
          <DxSimpleItem
            :col-span="3"
            :data-field="$t('registerProject.popPupTexture.arena')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: checkBoxSand ? newTexture.arena : calculateSand,
              onValueChanged: onChangeSand,
              mode: 'number',
              readOnly: checkBoxSand ? false : true,
            }"
          >
            <DxRangeRule
              min="0"
              max="100"
              :message="$t('outOfRange')"
            />
          </DxSimpleItem>
          <DxSimpleItem
            data-field=""
            editor-type="dxCheckBox"
            :editor-options="{
              value: checkBoxLimo,
              onValueChanged: onCheckBoxLimo,
            }"
          />
          <DxSimpleItem
            :col-span="3"
            :data-field="$t('registerProject.popPupTexture.limo')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: checkBoxLimo ? newTexture.limo : calculateLimo,
              onValueChanged: onChangeLimo,
              mode: 'number',
              readOnly: checkBoxLimo ? false : true,
            }"
          >
            <DxRangeRule
              min="0"
              max="100"
              :message="$t('outOfRange')"
            />
          </DxSimpleItem>
        </DxForm>
      </div>
      <f7-block-footer
        class="content-action-botton"
      >
        <f7-button
          class="dx-btn-cancel margin-right"
          raised
          type="default"
          text-color="grey"
          styling-mode="outlined"
          name="ButtonCancel"
          @click="closePopUp"
        >
          {{ $t('exit') }}
        </f7-button>
        <f7-button
          :class="`dx-btn-success ${enabled ? '': 'disabled'}`"
          raised
          type="success"
          styling-mode="contained"
          name="ButtonSave"
          @click="enabled ? followForm() : null"
        >
          {{ $t("EditOrder_ButtonSave_caption") }}
        </f7-button>
      </f7-block-footer>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import {
  DxForm, DxSimpleItem, DxGroupItem,
} from 'devextreme-vue/form';
import {
  DxRangeRule,
} from 'devextreme-vue/validator';

export default {
  name: 'FloorFormPopUp',
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxRangeRule,

  },
  data() {
    return {
      newTexture: {
        arcilla: 0,
        arena: 0,
        limo: 0,
        textureSelected: '',
      },
      checkBoxClay: false,
      checkBoxSand: false,
      checkBoxLimo: false,
      enabled: false,
    };
  },
  computed: {
    ...mapState('ProjectOpenAir', ['enabledPopUpTexture']),
    calculateClay(e) {
      return this.newTexture.limo !== 0 && this.newTexture.arena !== 0
        ? 100 - (this.newTexture.limo + this.newTexture.arena) : this.newTexture.arcilla;
    },
    calculateLimo() {
      return this.newTexture.arcilla !== 0 && this.newTexture.arena !== 0
        ? 100 - (this.newTexture.arcilla + this.newTexture.arena) : this.newTexture.limo;
    },
    calculateSand() {
      return (this.newTexture.arcilla !== 0 && this.newTexture.limo !== 0)
        ? 100 - (this.newTexture.arcilla + this.newTexture.limo) : this.newTexture.arena;
    },
    colCountByScreen() {
      return {
        sm: 4,
        md: 4,
      };
    },
  },
  methods: {
    screenByWidth(width) {
      return width < 720 ? 'sm' : 'md';
    },
    onChangeName(e) {
      this.newTexture.name = e.value;
      this.validate();
    },
    onChangeClay(e) {
      this.newTexture.arcilla = e.value;
      this.validate();
    },
    onChangeSand(e) {
      this.newTexture.arena = e.value;
      this.validate();
    },
    onChangeLimo(e) {
      this.newTexture.limo = e.value;
      this.validate();
    },
    onCheckBoxClay() {
      this.newTexture.arcilla = 0;
      this.checkBoxClay = !this.checkBoxClay;
      this.validate();
    },
    onCheckBoxSand() {
      this.newTexture.arena = 0;
      this.checkBoxSand = !this.checkBoxSand;
      this.validate();
    },
    onCheckBoxLimo() {
      this.newTexture.limo = 0;
      this.checkBoxLimo = !this.checkBoxLimo;
      this.validate();
    },
    closePopUp() {
      this.onHidden();
    },
    validate() {
      if (this.newTexture.name
          && this.newTexture.arcilla
          && this.newTexture.arena
          && this.newTexture.limo) {
        this.enabled = true;
      }
    },
    async followForm() {
      try {
        this.$f7.preloader.show();
        const data = {
          name: this.newTexture.name,
          clay: this.newTexture.arcilla,
          sand: this.newTexture.arena,
          silt: this.newTexture.limo,
        };
        await this.createDatabaseTexture(data);
        this.onHidden();
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onHidden() {
      this.setEnabledPopUpTexture(false);
      this.newTexture = {
        arcilla: 0,
        arena: 0,
        limo: 0,
        textureSelected: '',
      };
    },
    ...mapActions('ProjectOpenAir', ['setEnabledPopUpTexture']),
    ...mapActions('ProjectGreenHouse', ['createDatabaseTexture']),
  },
};
</script>
<style lang="scss" scoped>
.dx-texteditor-input-container {
  width: 100% !important;
}
</style>
